import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticationService } from "@core/services/auth.service";

export const authGuard = () => {
  return inject(AuthenticationService).isLogged() || (inject(Router).navigateByUrl(''), false);
};
